import { AppBar, Box, Button, TextField, styled, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as api from '../services/api'
import Loader from '../../components/Loader'
import styles from './login.module.css'
import logo from '../../assets/icons/logo.svg'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';


import ModalAlert from 'utils/components/modal-alert'
import Footer from 'components/Footer'
import { useSelector } from 'react-redux'

function ForgetPassword() {
    const version = useSelector(state => state.vers.value)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [openAlert, setOpenAlert] = useState(false)
    const [alertType, setAlertType] = useState('')
    const handleOpenAlert = (type) => {
        setOpenAlert(type)
    }

    const [data, setData] = useState({
        pid: "",
    });

    const [isValidpid, setIsValidpid] = useState(false);
    const [messageAlert, setMessageAlert] = useState('')

    const clickForgetPassword = async () => {
        setLoading(true)

        if (!data['pid']) {

            setAlertType('error')
            handleOpenAlert(true)
            setMessageAlert('กรุณากรอกเลขบัตรประจำตัวประชาชน')


        }
        if (data['pid']) {
            const regex = /^\d{13}$/;
            if (!regex.test(data['pid'])) {
                setIsValidpid(true);
                setAlertType('error')
                handleOpenAlert(true)
                setMessageAlert('กรุณาตรวจสอบเลขบัตรประจำตัวประชาชน')
            } else {
                setIsValidpid(false)

            }
        }


        let payload = {
            "username": data['pid'],
            "url": `${window.location.origin}/changePassword`,
            "platform": "mod-healthsystem-dashboard"
        }

        let result = await api.ApiForgetPassword(payload)
        if (result) {
            setAlertType('success')
            handleOpenAlert(true)
            setMessageAlert('ระบบได้ทำการรีเซ็ตรหัสผ่านแล้ว กรุณาไปตรวจสอบที่อีเมล')
            setLoading(false)

            setTimeout(() => {
                handleOpenAlert(false)
                navigate('/login')
            }, 3000);
        } else {
            setLoading(false)
        }
    }


    const handleAlert = () => {

    }



    return (
        <>
            <Loader loading={loading} />
            <AppBar
                position="sticky"
                sx={{
                    backgroundColor: '#FFFFFF',
                    padding: '10px',
                    color: '#000000',
                    "@media (max-width: 800px)": {
                        fontSize: '12px'
                    },
                }}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gridGap: '10px'
                    }}>
                        <img className={styles.logo} src={logo} />
                        <Box>
                            <div>ระบบข้อมูลสุขภาพกำลังพล สป.</div>
                            <div style={{ fontSize: '12px' }}>เวอร์ชัน {version || '-'}</div>
                        </Box>
                    </Box>
                    <Box>
                        <Button
                            variant='contaimed'
                            sx={{ backgroundColor: '#D1E6FF' }}
                            onClick={() => { navigate('/login') }}
                        >เข้าสู่ระบบ</Button>
                    </Box>
                </Box>
            </AppBar>

            <Box sx={design.container}>
                <Box sx={design.mainSection}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gridGap: '10px'
                    }}>
                        <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                        <Box sx={{
                            cursor: 'pointer'
                        }}
                            onClick={() => { navigate('/login') }}
                        >กลับไป หน้าแรก</Box>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        fontSize: '20px',
                        "@media (max-width: 1100px)": {
                            fontSize: '16px',
                        },
                        "@media (max-width: 800px)": {
                            fontSize: '14px',
                        },
                    }}>
                        <Box sx={{
                            display: 'grid',
                            gridGap: '20px',
                            width: '700px',
                            "@media (max-width: 1100px)": {
                                width: '500px'
                            },
                            "@media (max-width: 800px)": {
                                width: '100%'
                            },
                        }}>

                            <Typography sx={{
                                textAlign: 'center',
                                fontWeight: 600,
                                fontSize: '20px',

                            }}>ลืมรหัสผ่าน</Typography>


                            <Box>
                                <Box>เลขบัตรประจำตัวประชาชน</Box>
                                <TextField
                                    InputProps={{
                                        sx: {
                                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                                                display: 'none'
                                            },
                                            '& input[type=number]': {
                                                MozAppearance: 'textfield'
                                            },
                                        }
                                    }}
                                    type='number'
                                    placeholder='กรอกเลขบัตรประจำตัวประชาชน'
                                    size="small"
                                    fullWidth
                                    value={data["pid"]}
                                    name={"pid"}
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    onChange={(e) => {
                                        setData({ ...data, 'pid': !e.target.value ? null : String(e.target.value).slice(0, 13) });
                                    }}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: isValidpid ? 'red' : '',
                                            }
                                        },
                                    }}
                                />
                            </Box>



                            <Box sx={{ textAlign: 'center' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: "150px",
                                        "@media (max-width: 800px)": {
                                            width: "100px",
                                        },
                                    }}
                                    onClick={clickForgetPassword}
                                >รีเซ็ตรหัสผ่าน</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Footer />

            <ModalAlert
                loading={loading}
                title={'แจ้งเตือน'}
                type={alertType}
                message={messageAlert}
                open={openAlert}
                setOpen={setOpenAlert}
                handleChange={handleAlert}

            />
        </>
    )
}

const design = {
    container: {
        display: "flex",
        bgcolor: "neutral.light",
    },
    mainSection: {
        px: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        py: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        width: "100%",
        height: "100%",
        overflow: "auto",
    },
};

const StyledMobileDatePicker = styled(MobileDatePicker)({
    '& .MuiTextField-root': {
        margin: '20px',
    },
    "& .MuiInputBase-input": {
        padding: '8.5px 14px'
    }
});

const DatePicker = {
    width: '100%'
}

export default ForgetPassword
